/* ============
 * Hall of Fame Transformer
 * ============
 */

import Transformer from './transformer'
import teamTransformer from './team'
import athleteTransformer from './athlete'

export default class hofTransformer extends Transformer {
  /**
   * Method used to transform a fetched team
   *
   * @param team The fetched team
   * @param names The ppdbid to full name mapping
   *
   * @returns {Object} The transformed team
   */
  static fetch (data, names) {
    let hofParsed = {}
    let itemParsed = {}
    let hofType = ''
    let hofName = ''

    data.forEach(item => {
      if (item['property_Inductee_Type'].includes('Individual')) {
        itemParsed = athleteTransformer.fetch(item)
        hofName = itemParsed.ppdbid
        hofType = 'athletes'
        itemParsed.fullName = names && names[hofName] ? names[hofName] : itemParsed.title
      } else { // Team
        itemParsed = teamTransformer.fetch(item)
        hofName = itemParsed.teamName
        hofType = 'teams'
      }

      itemParsed['decades'].forEach((decade) => {
        hofParsed[decade] = hofParsed[decade] || []
        hofParsed[decade][hofType] = hofParsed[decade][hofType] || []
        hofParsed[decade][hofType].push(itemParsed)
      })

      hofParsed[hofType] = hofParsed[hofType] || []
      hofParsed[hofType].push(hofName)
    })

    return hofParsed
  }
}
